<section class="px-xs py-lg h-full bg-white" hlmCard>
  <div class="px-md" hlmCardHeader>
    <h3 hlmCardTitle>Liste des cartographies</h3>

    <div class="gap-md flex" hlmCardAction>
      @if (isEditing()) {
        <button (click)="cancelEdit()" hlmBtn variant="secondary">
          Annuler
          <ng-icon name="lucideX" />
        </button>
        <button (click)="submit()" hlmBtn>
          Valider
          <ng-icon name="lucideCheck" />
        </button>
      }
    </div>
  </div>
  <div class="gap-xl grid" hlmCardContent>
    <div hlmTableContainer>
      <table [formGroup]="form" hlmTable>
        <thead hlmTHead>
          <tr hlmTr>
            <th hlmTh></th>
            <th hlmTh>Nom de la cartographie</th>
            <th hlmTh>Statut</th>
            <th hlmTh>Actions</th>
          </tr>
        </thead>
        <tbody hlmTBody formArrayName="cartographies">
          @for (
            formGroupCartographie of cartographiesFa.controls;
            track formGroupCartographie.value.id;
            let i = $index
          ) {
            <ng-container [formGroupName]="i">
              <tr hlmTr>
                <td hlmTd>
                  <button (click)="toggleExpand(formGroupCartographie.value.id)" variant="ghost" size="icon" hlmBtn>
                    <ng-icon
                      class="collapse-icon"
                      [class.rotated]="isExpanded(formGroupCartographie.value.id)"
                      name="lucideChevronDown"
                    />
                  </button>
                </td>
                <td hlmTd>
                  @if (formGroupCartographie.value.editing) {
                    <input hlmInput formControlName="nom" />
                  } @else {
                    {{ formGroupCartographie.value.nom }}
                  }
                </td>
                <td hlmTd>
                  @if (!formGroupCartographie.value.editing) {
                    <label class="component-medium-medium flex items-center" hlmLabel>
                      <hlm-switch
                        [checked]="formGroupCartographie.value.estActive!"
                        (checkedChange)="toggleCartographieActive(i)"
                      />
                      {{ formGroupCartographie.value.estActive ? 'Activée' : 'Désactivée' }}
                    </label>
                  }
                </td>
                <td hlmTd>
                  <button
                    [hlmDropdownMenuTrigger]="actionsMenu"
                    [hlmDropdownMenuTriggerData]="{
                      $implicit: { i, estActive: formGroupCartographie.value.estActive },
                    }"
                    hlmBtn
                    variant="ghost"
                    size="icon"
                  >
                    <ng-icon name="lucideEllipsisVertical" />
                  </button>
                </td>
              </tr>
              @if (isExpanded(formGroupCartographie.value.id)) {
                <ng-container formArrayName="livrables">
                  @for (
                    formGroupLivrable of formGroupCartographie.controls.livrables.controls;
                    track formGroupLivrable.value.id;
                    let j = $index
                  ) {
                    <ng-container [formGroupName]="j">
                      <tr class="bg-background-underground border-stroke-neutral-light h-xxl border-b">
                        <td hlmTd>
                          @if ((formGroupLivrable.value.livrablesIntermediaires ?? []).length > 0) {
                            <button
                              (click)="toggleExpand(formGroupLivrable.value.id)"
                              variant="ghost"
                              size="icon"
                              hlmBtn
                            >
                              <ng-icon
                                class="collapse-icon"
                                [class.rotated]="isExpanded(formGroupLivrable.value.id)"
                                name="lucideChevronDown"
                              />
                            </button>
                          }
                        </td>
                        <td hlmTd>
                          <ng-container
                            *ngTemplateOutlet="
                              labelTemplate;
                              context: { label: 'Livrable', texte: formGroupLivrable.value.nom }
                            "
                          />
                        </td>
                        <td hlmTd>
                          @if (formGroupCartographie.value.editing) {
                            <hlm-field>
                              <hlm-date-picker
                                [buttonId]="'date' + formGroupLivrable.value.id"
                                formControlName="dateEcheance"
                              />
                            </hlm-field>
                          } @else {
                            <ng-container
                              *ngTemplateOutlet="
                                labelTemplate;
                                context: {
                                  label: 'Échéance',
                                  texte: (formGroupLivrable.value.dateEcheance | date: 'dd MMM yyyy') ?? 'N/A',
                                }
                              "
                            />
                          }
                        </td>
                        <td hlmTd>
                          @if (formGroupCartographie.value.editing) {
                            <button
                              (click)="ajouterLivrableIntermediaire(i, j)"
                              aria-label="Ajouter un livrable intermédiaire"
                              hlmBtn
                              variant="ghost"
                              size="icon"
                              hlmTooltipTrigger="Ajouter un livrable intermédiaire"
                            >
                              <ng-icon name="lucidePlus" />
                            </button>
                          }
                        </td>
                      </tr>
                      @if (isExpanded(formGroupLivrable.value.id)) {
                        <ng-container formArrayName="livrablesIntermediaires">
                          @for (
                            livrableIntermediaire of formGroupLivrable.controls.livrablesIntermediaires.controls;
                            track $index;
                            let i = $index
                          ) {
                            <tr
                              class="bg-background-underground border-stroke-neutral-light h-xxl border-b"
                              [formGroupName]="i"
                            >
                              <td hlmTd></td>
                              <td class="pl-xxl" hlmTd>
                                @if (formGroupCartographie.value.editing) {
                                  <input hlmInput formControlName="nom" />
                                } @else {
                                  <ng-container
                                    *ngTemplateOutlet="
                                      labelTemplate;
                                      context: {
                                        label: formGroupLivrable.value.nom,
                                        texte: livrableIntermediaire.value.nom,
                                      }
                                    "
                                  />
                                }
                              </td>
                              <td hlmTd>
                                @if (formGroupCartographie.value.editing) {
                                  <hlm-field>
                                    <hlm-date-picker formControlName="dateEcheance" buttonId="date" />
                                  </hlm-field>
                                } @else {
                                  <ng-container
                                    *ngTemplateOutlet="
                                      labelTemplate;
                                      context: {
                                        label: 'Échéance',
                                        texte:
                                          (livrableIntermediaire.value.dateEcheance | date: 'dd MMM yyyy') ?? 'N/A',
                                      }
                                    "
                                  />
                                }
                              </td>
                              <td hlmTd></td>
                            </tr>
                          }
                        </ng-container>
                      }
                    </ng-container>
                  }
                </ng-container>
              }
            </ng-container>
          } @empty {
            <tr hlmTr>
              <td hlmTd colspan="4">Aucune cartographie ne correspond à votre recherche</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <app-paginateur [store]="store" />
  </div>
</section>

<ng-template #labelTemplate let-label="label" let-texte="texte">
  <div class="flex flex-col">
    <span class="component-small-medium text-content-secondary">{{ label }}</span>
    <span>{{ texte }}</span>
  </div>
</ng-template>

<ng-template #actionsMenu let-ctx>
  <hlm-dropdown-menu>
    <hlm-dropdown-menu-group>
      @if (ctx.estActive) {
        <button (triggered)="duplicate(ctx.i)" hlmDropdownMenuItem>
          <ng-icon hlm name="lucideCopy" size="sm" />
          Dupliquer
        </button>
        <button (triggered)="toggleEdit(ctx.i)" hlmDropdownMenuItem>
          <ng-icon hlm name="lucidePen" size="sm" />
          Modifier
        </button>
      } @else {
        <button hlmDropdownMenuItem>
          <ng-icon hlm name="lucideTrash" size="sm" />
          Supprimer
        </button>
      }
    </hlm-dropdown-menu-group>
  </hlm-dropdown-menu>
</ng-template>
